import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var heightVar = 'var(--heightVar__123ve0h0)';
var root = createRuntimeFn({defaultClassName:'dynamicHeightTransition_root__123ve0h1',variantClassNames:{speed:{slow:'dynamicHeightTransition_root_speed_slow__123ve0h2',quick:'dynamicHeightTransition_root_speed_quick__123ve0h3'}},defaultVariants:{},compoundVariants:[]});

export { heightVar, root };
//# sourceMappingURL=dynamicHeightTransition.vanilla.mjs.map
